module.exports = __webpack_public_path__ + "static/guide5-695749043b7a7f5e243a85c3cb13e3a6.svg";